import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './App.css';
import CustomNav from './components/Nav/Nav';
import HeroSection from './components/HeroSection/HeroSection';
import ServicesSection from './components/ServicesSection/ServicesSection';
import PartnersSection from './components/Portfolio/PortfolioCarousel';
import TeamSection from './components/TeamSection/TeamSection';
import Footer from './components/Footer/Footer';
import ContactPage from './components/ContactPage/ContactPage';

function App() {
  return (
    <Router>
      <div className="App">
        {/* Helmet global (por defecto) */}
        <Helmet>
          <title>SBK Soluciones Digitales</title>
          <meta
            name="description"
            content="SBK Soluciones Digitales ofrece desarrollo web, branding, diseño y soluciones tecnológicas personalizadas para tu negocio."
          />
        </Helmet>

        <CustomNav />
        <Routes>
          <Route path="/" element={
            <>
              <Helmet>
                <title>Inicio - SBK Soluciones Digitales</title>
                <meta
                  name="description"
                  content="Desarrollo web, branding, diseño y soluciones tecnológicas personalizadas para tu negocio."
                />
              </Helmet>
              <HeroSection />
              <ServicesSection />
              <PartnersSection />
              <TeamSection />
            </>
          } />

          <Route path="/contact" element={
            <>
              <Helmet>
                <title>Contacto - SBK Soluciones Digitales</title>
                <meta
                  name="description"
                  content="Contáctanos para obtener soluciones digitales personalizadas."
                />
              </Helmet>
              <ContactPage />
            </>
          } />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
